import { z } from "zod";
import { FeedbackProductItemSchema } from "../feedback/feedback-product-item";

export const ProductReviewItemSchema = FeedbackProductItemSchema;

export type ProductReviewItemType = z.infer<typeof ProductReviewItemSchema>;
